"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createNamedObject;

var _createFunction = _interopRequireDefault(require("../function/createFunction"));

function createNamedObject(obj, key) {
  var Func = (0, _createFunction.default)(obj[key]);
  var namedObj = new Func();
  delete obj[key]; // eslint-disable-line no-param-reassign

  Object.assign(namedObj, obj);
  return namedObj;
}